import { createUserFileService } from './userFileService';

// Final score files live in the per-user 'scoredata' S3 namespace.
const service = createUserFileService('scoredata', 'score file');

export const saveScoreFile = service.save;
export const listScoreFiles = service.list;
export const loadScoreFile = service.load;
export const deleteScoreFile = service.remove;
export const renameScoreFile = service.rename;
